// Lo pagado con su barra (contra el mayor de la lista) y su porcentaje del total del periodo.
import { formatMoneyCents } from '@/shared/lib/format/money';
import { sharePct } from '../../lib/payoutRows';

export function ShareCell({
    paidCents,
    totalCents,
    maxCents,
}: {
    paidCents: number;
    totalCents: number;
    maxCents: number;
}) {
    const width = maxCents > 0 ? (paidCents / maxCents) * 100 : 0;
    return (
        <div className="flex items-center gap-2">
            <div className="h-1.5 flex-1 rounded bg-muted">
                <div className="h-full rounded bg-primary" style={{ width: `${String(width)}%` }} />
            </div>
            <span className="w-[40px] text-right text-[10px] text-muted-foreground">
                {sharePct(paidCents, totalCents).toFixed(1)}%
            </span>
            <span className="w-[88px] text-right font-semibold tabular-nums">
                {formatMoneyCents(paidCents)}
            </span>
        </div>
    );
}
